import { _times, _plus, _div, _toFixed } from '@/helpers/bigNumber'

export const amountBase = state => {
  let base = _times(_div(state.product.totalAmount, state.product.count), state.quantity)
  let result = isNaN(base) ? 0 : _toFixed(base, 2)
  return result
}

export const amountBeforeTaxes = (state, getters) => {
  let total = _plus(getters['amountBase'], getters['discountsCharges/total'])
  let result = isNaN(total) ? 0 : _toFixed(total, 2)
  return result
}

export const subtotal = (state, getters) => {
  // 70612 A nivel de linea los impuestos no se deben definir, debido a los desc globales.
  let total = getters['amountBeforeTaxes'] /* 70612 + getters['taxes/total'] */
  let result = isNaN(total) ? 0 : _toFixed(total, 2)
  return result
}

export const getObject = (state, getters) => {
  let {
    key,
    quantity,
    orderSender,
    orderReceiver,
    observation,
    itemStartDate,
    itemEndDate
  } = state
  let {
    vendor,
    payer,
    description,
    totalAmount,
    unit,
    count
  } = state.product
  let {
    list: deliveryNotes
  } = state.deliveryNotes
  return {
    key,
    value: {
      product: {
        vendor,
        payer,
        description,
        totalAmount,
        unit,
        count
      },
      quantity,
      orderSender,
      orderReceiver,
      observation,
      itemStartDate,
      itemEndDate,
      discountsCharges: getters['discountsCharges/apificate'],
      taxes: getters['taxes/apificate'],
      deliveryNotes: deliveryNotes.map(k => Object.assign({}, state.deliveryNotes._[k])),
      description,
      unit,
      amount: _toFixed(getters['amountBase'], 2),
      discountsPercent: getters['discountsCharges/totalPercent'],
      totalDiscounts: _toFixed(getters['discountsCharges/total'], 2),
      taxesPercent: getters['taxes/totalPercent'],
      // 70612 totalTaxes: getters['taxes/total'],
      amountBeforeTaxes: _toFixed(getters['amountBeforeTaxes'], 2),
      subtotal: _toFixed(getters['subtotal'], 2),
      inmobilizedData: getters['inmobilizedData/apificate'],
      officeFinancialExpenses: getters['officeFinancialExpenses/apificate']
    }
  }
}
